export var PAGE_CONTAINER_MAX_WIDTH = {
  xs: 'calc(100% - 32px)',
  md: 'calc(100% - 48px)',
  xl: 'calc(100% - 64px)'
};